// src/components/ui/badge.jsx
import React from "react";

export function Badge({
  children,
  className = "",
  variant = "default",
  ...props
}) {
  const variants = {
    default: "bg-gray-100 text-gray-800 border-gray-200",
    primary: "bg-indigo-100 text-indigo-800 border-indigo-200",
    secondary: "bg-blue-100 text-blue-800 border-blue-200",
    destructive: "bg-red-100 text-red-800 border-red-200",
    outline: "text-gray-700 border-gray-200",
    success: "bg-green-100 text-green-800 border-green-200",
    warning: "bg-yellow-100 text-yellow-800 border-yellow-200",
  };

  return (
    <span
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium ${variants[variant]} ${className}`}
      {...props}
    >
      {children}
    </span>
  );
}

export default Badge;
